'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function Footer() {
  const pathname = usePathname();
  const isFa = !pathname.startsWith('/en');
  const lang = isFa ? 'fa' : 'en';
  const isPanel = pathname?.includes('/panel') || pathname?.includes('/admin');
  
  if (isPanel) {
    return null;
  }

  const bgColor = '#f8fafc';
  const textColor = '#64748b';
  const titleColor = '#1e293b';
  const borderColor = 'rgba(0, 162, 255, 0.15)';
  const btnBg = 'rgba(0, 162, 255, 0.05)';

  return (
    <>
      {/* استایل‌های ریسپانسیو دو ستونه و جذاب موبایل */}
      <style dangerouslySetInnerHTML={{__html: `
        .footer-container {
          width: 100%;
          max-width: 100vw;
          box-sizing: border-box;
          overflow-x: hidden;
        }
        .footer-social-grid {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .footer-link-item {
          color: ${textColor};
          text-decoration: none;
          font-size: 13.5px;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
          padding: 4px 0;
        }
        .footer-link-item:hover {
          color: #0284c7 !important;
          transform: translateX(${isFa ? '-3px' : '3px'});
        }
        @media (max-width: 768px) {
          .footer-container {
            padding: 36px 16px 24px !important;
          }
          .footer-grid {
            display: grid !important;
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 22px 14px !important;
          }
          .footer-brand-col {
            grid-column: 1 / -1 !important;
            text-align: center;
            padding-bottom: 14px;
            border-bottom: 1px dashed rgba(0, 162, 255, 0.18);
          }
          .footer-brand-col p {
            max-width: 440px;
            margin: 0 auto !important;
            font-size: 13px !important;
            line-height: 1.7 !important;
          }
          .footer-col-title {
            font-size: 14px !important;
            margin-bottom: 12px !important;
            padding-bottom: 6px !important;
          }
          .footer-link-item {
            font-size: 12.5px !important;
            padding: 3px 0 !important;
          }
          .footer-contact-item {
            font-size: 12.5px !important;
          }
          .footer-social-col {
            grid-column: 1 / -1 !important;
            padding-top: 14px;
            border-top: 1px dashed rgba(0, 162, 255, 0.18);
          }
          .footer-social-grid {
            display: grid !important;
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 10px !important;
            width: 100% !important;
          }
          .footer-social-btn {
            width: 100% !important;
            justify-content: center !important;
            box-sizing: border-box !important;
            padding: 10px 8px !important;
            font-size: 12px !important;
            text-align: center;
            border-radius: 10px !important;
          }
          .footer-bottom {
            flex-direction: column !important;
            justify-content: center !important;
            text-align: center;
            gap: 14px !important;
            padding-top: 18px !important;
          }
          .footer-bottom-links {
            justify-content: center !important;
            width: 100%;
            gap: 18px !important;
          }
        }
      `}} />

      <footer id="footer" className="footer-container" style={{ 
        background: bgColor,
        backdropFilter: isPanel ? 'none' : 'blur(10px)',
        borderTop: `1px solid ${borderColor}`,
        padding: '60px 5% 30px', 
        color: textColor, 
        fontFamily: 'sans-serif',
        position: 'relative',
        zIndex: 10
      }} dir={isFa ? 'rtl' : 'ltr'}>
        
        <div style={{ maxWidth: '1200px', width: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '40px', boxSizing: 'border-box' }}>
          
          <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))', gap: '35px', alignItems: 'flex-start', width: '100%' }}>
            
            {/* ستون اول: معرفی برند */}
            <div className="footer-brand-col">
              <div style={{ fontSize: '24px', fontWeight: '900', color: titleColor, letterSpacing: '1px', marginBottom: '12px' }}>
                PASS<span style={{ color: '#00d2ff' }}>FUND</span>
              </div>
              <p style={{ fontSize: '14px', lineHeight: '1.8', color: textColor, margin: 0 }}>
                {isFa 
                  ? 'میانبر شما به سوی تریدر حرفه‌ای شدن. با سرمایه ما معامله کنید و تا ۹۰٪ سود واقعی را برداشت کنید.' 
                  : 'Your shortcut to becoming a professional trader. Trade with our capital and withdraw up to 90% real profits.'}
              </p>
            </div>

            {/* ستون دوم: دسترسی سریع */}
            <div className="footer-col-quick">
              <h4 className="footer-col-title" style={{ color: titleColor, fontSize: '15px', fontWeight: 'bold', marginBottom: '18px', borderBottom: '2px solid rgba(0, 162, 255, 0.4)', paddingBottom: '8px', display: 'inline-block' }}>
                {isFa ? 'دسترسی سریع' : 'Quick Links'}
              </h4>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <li>
                  <Link href={`/${lang}`} className="footer-link-item">
                    <span style={{ color: '#00d2ff', fontSize: '10px' }}>◆</span>
                    {isFa ? 'صفحه اصلی' : 'Home'}
                  </Link>
                </li>
                <li>
                  <Link href={`/${lang}/panel/buy-plan`} className="footer-link-item">
                    <span style={{ color: '#00d2ff', fontSize: '10px' }}>◆</span>
                    {isFa ? 'خرید چالش (پلان‌ها)' : 'Buy Challenge'}
                  </Link>
                </li>
                <li>
                  <Link href={`/${lang}/rules`} className="footer-link-item">
                    <span style={{ color: '#00d2ff', fontSize: '10px' }}>◆</span>
                    {isFa ? 'قوانین و مقررات' : 'Rules & Regulations'}
                  </Link>
                </li>
                <li>
                  <Link href={`/${lang}/panel`} className="footer-link-item">
                    <span style={{ color: '#00d2ff', fontSize: '10px' }}>◆</span>
                    {isFa ? 'پنل کاربری' : 'User Panel'}
                  </Link>
                </li>
                <li>
                  <Link href={`/${lang}/contact`} className="footer-link-item">
                    <span style={{ color: '#00d2ff', fontSize: '10px' }}>◆</span>
                    {isFa ? 'تماس با ما' : 'Contact Us'}
                  </Link>
                </li>
              </ul>
            </div>

            {/* ستون سوم: ارتباط با ما */}
            <div className="footer-col-contact">
              <h4 className="footer-col-title" style={{ color: titleColor, fontSize: '15px', fontWeight: 'bold', marginBottom: '18px', borderBottom: '2px solid rgba(0, 162, 255, 0.4)', paddingBottom: '8px', display: 'inline-block' }}>
                {isFa ? 'ارتباط با ما' : 'Contact Us'}
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px' }}>
                <a 
                  href="mailto:support@passfund.com" 
                  className="footer-contact-item"
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', color: textColor, textDecoration: 'none', wordBreak: 'break-all' }}
                >
                  <span style={{ color: '#0ea5e9' }}>✉</span> support@passfund.com
                </a>
                <div className="footer-contact-item" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: textColor }}>
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#10b981', display: 'inline-block', boxShadow: '0 0 6px #10b981' }}></span>
                  {isFa ? 'پشتیبانی ۲۴ ساعته آنلاین' : '24/7 Online Support'}
                </div>
                <div>
                  <Link 
                    href={`/${lang}/contact`}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      color: '#0284c7',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      textDecoration: 'none',
                      marginTop: '4px',
                      padding: '5px 10px',
                      borderRadius: '6px',
                      backgroundColor: 'rgba(2, 132, 199, 0.08)'
                    }}
                  >
                    {isFa ? 'صفحه تماس و فرم پیام ←' : 'Contact Page & Form →'}
                  </Link>
                </div>
              </div>
            </div>

            {/* ستون چهارم: شبکه‌های اجتماعی و پشتیبانی */}
            <div className="footer-social-col">
              <h4 className="footer-col-title" style={{ color: titleColor, fontSize: '15px', fontWeight: 'bold', marginBottom: '18px', borderBottom: '2px solid rgba(0, 162, 255, 0.4)', paddingBottom: '8px', display: 'inline-block' }}>
                {isFa ? 'ارتباط و شبکه‌های اجتماعی' : 'Support & Channels'}
              </h4>
              <div className="footer-social-grid">
                <a 
                  href="https://t.me/proppasssupport" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-social-btn"
                  style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    padding: '8px 14px', 
                    background: btnBg, 
                    border: `1px solid ${borderColor}`, 
                    borderRadius: '10px', 
                    color: '#00d2ff',
                    textDecoration: 'none', 
                    fontSize: '13px',
                    fontWeight: 'bold',
                    transition: 'all 0.2s'
                  }}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/></svg>
                  {isFa ? 'پشتیبانی تلگرام' : 'Telegram Support'}
                </a>
                <a 
                  href="https://rubika.ir/passfundsupport" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-social-btn"
                  style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    padding: '8px 14px', 
                    background: btnBg, 
                    border: `1px solid ${borderColor}`, 
                    borderRadius: '10px', 
                    color: '#c084fc',
                    textDecoration: 'none', 
                    fontSize: '13px',
                    fontWeight: 'bold',
                    transition: 'all 0.2s'
                  }}
                >
                  <span style={{ fontSize: '14px' }}>🟣</span>
                  {isFa ? 'پشتیبانی روبیکا (@passfundsupport)' : 'Rubika Support (@passfundsupport)'}
                </a>
                <a 
                  href="https://t.me/proppassfunded" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-social-btn"
                  style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    padding: '8px 14px', 
                    background: btnBg, 
                    border: `1px solid ${borderColor}`, 
                    borderRadius: '10px', 
                    color: '#38bdf8',
                    textDecoration: 'none', 
                    fontSize: '13px',
                    fontWeight: 'bold',
                    transition: 'all 0.2s'
                  }}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/></svg>
                  {isFa ? 'کانال رسمی تلگرام' : 'Telegram Channel'}
                </a>
                <Link 
                  href={`/${lang}/panel/tickets`}
                  className="footer-social-btn"
                  style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    padding: '8px 14px', 
                    background: 'rgba(16, 185, 129, 0.08)', 
                    border: '1px solid rgba(16, 185, 129, 0.3)', 
                    borderRadius: '10px', 
                    color: '#10b981',
                    textDecoration: 'none', 
                    fontSize: '13px',
                    fontWeight: 'bold',
                    transition: 'all 0.2s'
                  }}
                >
                  <span style={{ fontSize: '14px' }}>🎫</span>
                  {isFa ? 'ثبت تیکت در پنل' : 'In-App Ticket'}
                </Link>
              </div>
            </div>

          </div>

          <div style={{ width: '100%', height: '1px', backgroundColor: borderColor }}></div>

          <div className="footer-bottom" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
            
            <p style={{ margin: 0, fontSize: '13px', color: textColor }}>
              {isFa ? 'تمامی حقوق این پلتفرم محفوظ است © ۲۰۲۶ پس‌فاند.' : 'All rights reserved © 2026 PassFund.'}
            </p>

            <div className="footer-bottom-links" style={{ display: 'flex', gap: '25px', flexWrap: 'wrap' }}>
              <Link href={`/${lang}/rules`} style={{ color: textColor, textDecoration: 'none', fontSize: '13px' }}>
                {isFa ? 'قوانین و مقررات' : 'Terms & Conditions'}
              </Link>
              <Link href={`/${lang}/rules`} style={{ color: textColor, textDecoration: 'none', fontSize: '13px' }}>
                {isFa ? 'حریم خصوصی' : 'Privacy Policy'}
              </Link>
            </div>

          </div>

        </div>
      </footer>
    </>
  );
}